import { createSlice } from '@reduxjs/toolkit'
const {
  actions: {
    setTableColumnSelection
  },
  reducer
} = createSlice({
  name: 'uiConfig',
  initialState: {
    tableColumnSelections: {}
  },
  reducers: {
    /**
     * Updates the table column selections in the state.
     *
     * @param {Object} state - The current state of the slice.
     * @param {Object} payload - The payload containing the updates.
     * @param {string} payload.id - The ID of the table being updated.
     * @param {Object} payload.columnSelections - The updated column selections for the table.
     * @returns {Object} The updated state with the new table column selections.
     */
    setTableColumnSelection: (state, { payload }) => ({
      ...state,
      tableColumnSelections: {
        ...state.tableColumnSelections,
        [payload.id]: payload.columnSelections
      }
    })
  }
})

export default reducer

export {
  setTableColumnSelection
}
